// components/SimpleExport.js
import React, { useState, useEffect } from 'react';
 import simpleExportService from '../../../../services/simpleExportService';

const SimpleExport = () => {
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [bases, setBases] = useState([]);
  const [selectedBase, setSelectedBase] = useState('');
  const [statistics, setStatistics] = useState(null);

  useEffect(() => {
    loadBases();
    loadStatistics();
  }, []);

  const loadBases = async () => {
    try {
      const basesList = await simpleExportService.getBases();
      setBases(basesList);
    } catch (error) {
      setMessage('❌ هێنانی لیستی بنکەکان سەرنەکەوت');
    }
  };

  const loadStatistics = async () => {
    try {
      const stats = await simpleExportService.getStatistics();
      setStatistics(stats);
    } catch (error) {
      console.error('Failed to load statistics:', error);
    }
  };

  const handleExport = async (exportType, base = null) => {
    setLoading(true);
    setMessage('');

    try {
      let result;

      switch (exportType) {
        case 'all':
          result = await simpleExportService.exportAll();
          break;
        case 'hator-only':
          result = await simpleExportService.exportHatorOnly();
          break;
        case 'not-hator-only':
          result = await simpleExportService.exportNotHatorOnly();
          break;
        case 'by-base':
          if (!selectedBase) {
            throw new Error('تکایە بنکەیەک هەڵبژێرە');
          }
          result = await simpleExportService.exportByBase(selectedBase);
          break;
        case 'hator-by-base':
          if (!selectedBase) {
            throw new Error('تکایە بنکەیەک هەڵبژێرە');
          }
          result = await simpleExportService.exportHatorByBase(selectedBase);
          break;
        case 'not-hator-by-base':
          if (!selectedBase) {
            throw new Error('تکایە بنکەیەک هەڵبژێرە');
          }
          result = await simpleExportService.exportNotHatorByBase(selectedBase);
          break;
        default:
          throw new Error('جۆری پەرستە نەناسراوە');
      }

      setMessage(`✅ ${result.filename} - پەرستەکە سەرکەوتووبوو`);
    } catch (error) {
      setMessage(`❌ ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  const mainExportButtons = [
    {
      type: 'all',
      title: '📊 هەموو داتاکان',
      description: 'هەموو داتاکان لە فایلێکدا',
      color: '#28a745'
    },
    {
      type: 'hator-only',
      title: '✅ تەنها هاتوو',
      description: 'تەنها کەسە هاتووەکان',
      color: '#17a2b8'
    },
    {
      type: 'not-hator-only',
      title: '❌ تەنها نەهاتوو',
      description: 'تەنها کەسە نەهاتووەکان',
      color: '#dc3545'
    }
  ];

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <h2 style={styles.title}> گۆڕین بۆ فایلی Excel</h2>
        {/* <p style={styles.subtitle}>پەرستەکردنی داتاکان بە شێوازی ئاسان</p> */}
      </div>

      {/* کۆی ئامار
      {statistics && (
        <div style={styles.section}>
          <h3 style={styles.sectionTitle}>کۆی ئامار</h3>
          <div style={styles.statsSummary}>
            <div style={styles.statItem}>
              <div style={styles.statNumber}>{statistics.total_summary?'.کۆی گشتی '|| '0'}</div>
              <div style={styles.statLabel}>کۆی گشتی</div>
            </div>
            <div style={styles.statItem}>
              <div style={styles.statNumber}>{statistics.total_summary?.کۆی هاتوو || 0}</div>
              <div style={styles.statLabel}>هاتوو</div>
            </div>
            <div style={styles.statItem}>
              <div style={styles.statNumber}>{statistics.total_summary?.کۆی نەهاتوو || 0}</div>
              <div style={styles.statLabel}>نەهاتوو</div>
            </div>
          </div>
        </div>
      )} */}

      {/* پەرستەکردنی سەرەکی */}
      <div style={styles.section}>
        <h3 style={styles.sectionTitle}>Export All Data</h3>
        <div style={styles.buttonsGrid}>
          {mainExportButtons.map((button) => (
            <button
              key={button.type}
              onClick={() => handleExport(button.type)}
              disabled={loading}
              style={{
                ...styles.mainButton,
                backgroundColor: button.color
              }}
            >
              <div style={styles.buttonContent}>
                <div style={styles.buttonTitle}>{button.title}</div>
                <div style={styles.buttonDescription}>{button.description}</div>
              </div>
            </button>
          ))}
        </div>
      </div>

      {/* پەرستەکردنی بەپێی بنکە */}
      <div style={styles.section}>
        <h3 style={styles.sectionTitle}> بەپێی بنکە</h3>
        
        <div style={styles.baseSelection}>
          <select 
            value={selectedBase}
            onChange={(e) => setSelectedBase(e.target.value)}
            style={styles.baseSelect}
          >
            <option value="">بنکەیەک هەڵبژێرە</option>
            {bases.map((base) => (
              <option key={base} value={base}>{base}</option>
            ))}
          </select>
        </div>

        {selectedBase && (
          <div style={styles.baseButtons}>
            <button
              onClick={() => handleExport('by-base')}
              disabled={loading}
              style={styles.baseButton}
            >
              📁 هەموو داتای {selectedBase}
            </button>
            <button
              onClick={() => handleExport('hator-by-base')}
              disabled={loading}
              style={styles.baseButton}
            >
              ✅ هاتووەکانی {selectedBase}
            </button>
            <button
              onClick={() => handleExport('not-hator-by-base')}
              disabled={loading}
              style={styles.baseButton}
            >
              ❌ نەهاتووەکانی {selectedBase}
            </button>
          </div>
        )}
      </div>

      {/* ئاماری بنکەکان */}
      {statistics && statistics.statistics && (
        <div style={styles.section}>
          <h3 style={styles.sectionTitle}>ئاماری بنکەکان</h3>
          <div style={styles.statsTable}>
            <div style={styles.tableHeader}>
              <div style={styles.tableCell}>بنکە</div>
              <div style={styles.tableCell}>کۆ</div>
              <div style={styles.tableCell}>هاتوو</div>
              <div style={styles.tableCell}>نەهاتوو</div>
              <div style={styles.tableCell}>ڕێژە</div>
            </div>
            {statistics.statistics.map((stat, index) => (
              <div key={index} style={styles.tableRow}>
                <div style={styles.tableCell}>{stat.بنکە}</div>
                <div style={styles.tableCell}>{stat.کۆ}</div>
                <div style={styles.tableCell}>{stat.هاتوو}</div>
                <div style={styles.tableCell}>{stat.نەهاتوو}</div>
                {/* <div style={styles.tableCell}>{stat.ڕێژەی هاتوو}</div> */}
              </div>
            ))}
          </div>
        </div>
      )}

      {message && (
        <div style={{
          ...styles.message,
          backgroundColor: message.includes('❌') ? '#f8d7da' : '#d4edda',
          color: message.includes('❌') ? '#721c24' : '#155724'
        }}>
          {message}
        </div>
      )}
    </div>
  );
};

const styles = {
  container: {
    fontFamily: 'Arial, sans-serif',
    maxWidth: '800px',
    margin: '0 auto',
    padding: '20px',
    direction: 'rtl',
    backgroundColor: '#f8f9fa',
    borderRadius: '12px',
    boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
  },
  header: {
    textAlign: 'center',
    marginBottom: '30px',
    paddingBottom: '20px',
    borderBottom: '3px solid #28a745',
  },
  title: {
    color: '#2E7D32',
    fontSize: '28px',
    marginBottom: '10px',
    fontWeight: 'bold',
  },
  subtitle: {
    color: '#666',
    fontSize: '16px',
  },
  section: {
    backgroundColor: 'white',
    padding: '25px',
    marginBottom: '20px',
    borderRadius: '8px',
    border: '1px solid #e0e0e0',
    boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
  },
  sectionTitle: {
    color: '#333',
    fontSize: '20px',
    marginBottom: '20px',
    borderRight: '4px solid #28a745',
    paddingRight: '15px',
    fontWeight: 'bold',
  },
  statsSummary: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(120px, 1fr))',
    gap: '15px',
  },
  statItem: {
    textAlign: 'center',
    padding: '15px',
    backgroundColor: '#e9ecef',
    borderRadius: '8px',
  },
  statNumber: {
    fontSize: '24px',
    fontWeight: 'bold',
    color: '#333',
    marginBottom: '5px',
  },
  statLabel: {
    fontSize: '14px',
    color: '#666',
    fontWeight: 'bold',
  },
  buttonsGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
    gap: '15px',
  },
  mainButton: {
    padding: '20px',
    color: 'white',
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer',
    textAlign: 'right',
    transition: 'all 0.3s ease',
  },
  buttonContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: '5px',
  },
  buttonTitle: {
    fontSize: '16px',
    fontWeight: 'bold',
  },
  buttonDescription: {
    fontSize: '12px',
    opacity: 0.9,
  },
  baseSelection: {
    marginBottom: '20px',
  },
  baseSelect: {
    padding: '10px',
    border: '1px solid #ddd',
    borderRadius: '6px',
    fontSize: '14px',
    width: '100%',
  },
  baseButtons: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
    gap: '10px',
  },
  baseButton: {
    padding: '12px',
    backgroundColor: '#6c757d',
    color: 'white',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
    fontSize: '14px',
    transition: 'all 0.3s ease',
  },
  statsTable: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1px',
    backgroundColor: '#dee2e6',
    borderRadius: '6px',
    overflow: 'hidden',
  },
  tableHeader: {
    display: 'grid',
    gridTemplateColumns: '2fr 1fr 1fr 1fr 1fr',
    backgroundColor: '#343a40',
    color: 'white',
    fontWeight: 'bold',
  },
  tableRow: {
    display: 'grid',
    gridTemplateColumns: '2fr 1fr 1fr 1fr 1fr',
    backgroundColor: 'white',
  },
  tableCell: {
    padding: '10px',
    borderBottom: '1px solid #dee2e6',
    textAlign: 'center',
  },
  message: {
    marginTop: '20px',
    padding: '15px',
    borderRadius: '6px',
    textAlign: 'center',
    fontWeight: 'bold',
  },
};

// Add hover effects
Object.assign(styles.mainButton, {
  ':hover': {
    opacity: 0.9,
    transform: 'translateY(-2px)',
  }
});

Object.assign(styles.baseButton, {
  ':hover': {
    backgroundColor: '#5a6268',
    transform: 'translateY(-1px)',
  }
});

export default SimpleExport;